import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';

const usePortfolioSiteExplorerAnalytics = () => {
    const sendTrackEvent = (ga: { action: string; category?: string; label?: string; project?: string }) => {
        analyticsTracking.trackEvent({
            ...ga,
            category: 'Portfolio site explorer',
            app: AppName.PORTFOLIO_SITE_EXPLORER,
        });
    };

    const trackListViewTabClick = () => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_list_view_tab_click',
        });
    };

    const trackMapViewTabClick = () => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_map_view_tab_click',
        });
    };

    const trackDetailedExplainerOpen = (explainerSlug: string, view: 'map' | 'list') => {
        sendTrackEvent({
            action: `portfolio_site_explorer_detailed_explainer_open-${view}`,
            label: explainerSlug,
        });
    };

    const trackColumnSortClick = (columnName: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_column_sort_click',
            label: columnName,
        });
    };

    const trackViewButtonClick = (siteId: string, hasEdna: boolean, hasHabitatInsights: boolean, locationForTracking?: string) => {
        let destination = 'unknown';
        if (hasEdna || hasHabitatInsights) {
            destination = 'site_summary';
        }

        sendTrackEvent({
            action: 'portfolio_site_explorer_view_button_click',
            label: locationForTracking ? `${locationForTracking}:${destination}` : destination,
            project: siteId,
        });
    };

    const trackMapTypeChange = (mapType: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_map_type_change',
            label: mapType,
        });
    };

    const trackMapZoom = (zoomLevel: number) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_map_zoom',
            label: zoomLevel.toString(),
        });
    };

    const trackMapDrag = () => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_map_drag',
        });
    };

    const trackSpeciesRiskModalOpen = (siteId: string, speciesType: 'invasive' | 'iucn', source: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_species_risk_modal_open',
            label: `${source}:${speciesType}`,
            project: siteId,
        });
    };

    const trackSidebarIndicatorHelpHover = (explainerSlug: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_sidebar_indicator_help_hover',
            label: explainerSlug,
        });
    };

    const trackSidebarIndicatorSelect = (indicator: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_sidebar_indicator_select',
            label: indicator,
        });
    };

    const trackSiteMarkerHover = (siteId: string) => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_site_marker_hover',

            project: siteId,
        });
    };

    const trackSiteClick = (siteId: string, source: 'map' | 'sidebar') => {
        sendTrackEvent({
            action: 'portfolio_site_explorer_site_click',
            label: source,
            project: siteId,
        });
    };

    return {
        sendTrackEvent,
        trackListViewTabClick,
        trackMapViewTabClick,
        trackDetailedExplainerOpen,
        trackColumnSortClick,
        trackViewButtonClick,
        trackSpeciesRiskModalOpen,
        trackSidebarIndicatorHelpHover,
        trackSidebarIndicatorSelect,
        trackSiteMarkerHover,
        trackSiteClick,
        trackMapTypeChange,
        trackMapZoom,
        trackMapDrag,
    };
};

export default usePortfolioSiteExplorerAnalytics;
